<template>
  <v-dialog
    v-model="computedSnowmakingAirwatergunVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('snowmaking', 'airwaterguns', false);
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedAirwatergunNum }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- zoomto icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="
              zoomTo({
                center: computedLatLng[0].geometry.coordinates,
                level: 18
              });
              methodCloseListLayer('snowmaking', 'airwaterguns');
              methodToggleSingleLayer('snowmaking', 'airwaterguns', false);
            "
          >
            <v-icon>map</v-icon>
          </v-btn>
          <span>See on map</span>
        </v-tooltip>

        <!-- delete icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="disable_edit"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>

        <!-- edit icon -->
        <v-tooltip bottom>
          <v-btn
            v-if="disable_edit"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            v-else
            icon
            slot="activator"
            color="info"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="
          background-color: black;
          padding-left: 30px;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        "
      >
        <v-data-table
          :items="computedSnowmakingAirwatergunGeoJsonFeature"
          :loading="computedSnowmakingAirwatergunsLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr v-if="computedSameLocations && computedSameLocations.length">
              <td>Airwaterguns at same location</td>
              <td>
                <v-btn
                  color="primary"
                  v-for="item in computedSameLocations"
                  :key="item.properties.id"
                  @click="
                    methodToggleSingleLayer(
                      'snowmaking',
                      'airwaterguns',
                      true,
                      item.properties.id
                    )
                  "
                >
                  {{ item.properties.length }}'
                  {{ item.properties.model }}
                  {{ item.properties.gun_number }}</v-btn
                >
              </td>
            </tr>
            <tr>
              <td>Gun #</td>
              <td>
                {{ props.item.properties.gun_number }}
              </td>
            </tr>
            <tr>
              <td>Was demo</td>
              <td>
                <v-text-field
                  ref="ref_was_demo"
                  name="was_demo"
                  v-model="props.item.properties.was_demo"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Gun Style</td>
              <td>
                <v-select
                  ref="ref_gun_style"
                  :items="computedGunStyle"
                  v-model="props.item.properties.gun_style"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Gun Model</td>
              <td>
                <v-select
                  ref="ref_model"
                  :items="computedGunModel"
                  v-model="props.item.properties.model"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Valve</td>
              <td>
                <v-select
                  ref="ref_valve"
                  :items="computedValve"
                  v-model="props.item.properties.valve"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>CFM</td>
              <td>
                <v-text-field
                  ref="ref_cfm"
                  name="cfm"
                  v-model="props.item.properties.cfm"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Flow GPM</td>
              <td>
                <v-text-field
                  ref="ref_flow_gpm"
                  name="flow_gpm"
                  v-model="props.item.properties.flow_gpm"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Length</td>
              <td>
                <v-text-field
                  ref="ref_length"
                  name="length"
                  v-model="props.item.properties.length"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Serial #</td>
              <td>
                <v-text-field
                  ref="ref_serial"
                  name="serial"
                  v-model="props.item.properties.serial"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Gun Base</td>
              <td>
                <v-select
                  ref="ref_gun_base"
                  :items="computedGunBase"
                  v-model="props.item.properties.gun_base"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Skid</td>
              <td>
                <v-select
                  ref="ref_skid"
                  :items="computedGunSkid"
                  v-model="props.item.properties.skid"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Jack style</td>
              <td>
                <v-select
                  ref="ref_jack_style"
                  :items="computedGunJack"
                  v-model="props.item.properties.jack_style"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Status</td>
              <td>
                <v-select
                  ref="ref_status"
                  :items="opt_status"
                  v-model="props.item.properties.status"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Location</td>
              <td>
                <v-autocomplete
                  ref="ref_location"
                  v-model="props.item.geometry.coordinates"
                  :items="computedLocations"
                  :disabled="disable_edit"
                ></v-autocomplete>
              </td>
            </tr>
            <tr>
              <td>Last moved by</td>
              <td>
                <v-text-field
                  ref="ref_moved_by"
                  name="moved_by"
                  v-model="props.item.properties.moved_by"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Acquired</td>
              <td>
                <v-text-field
                  ref="ref_acquired"
                  name="acquired"
                  v-model="props.item.properties.acquired"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Purchased</td>
              <td>
                <v-text-field
                  ref="ref_purchased"
                  name="purchased"
                  v-model="props.item.properties.purchased"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Last Edit</td>
              <td v-if="disable_edit">{{ props.item.properties.edit_by }}</td>
              <td v-if="!disable_edit">{{ computedAuth.profile.email }}</td>
            </tr>
            <tr>
              <td>Modified</td>
              <td>
                {{ props.item.properties.modified.split("T")[0] }}
              </td>
            </tr>
            <tr>
              <td>Comments</td>
              <td>
                <v-textarea
                  name="notes"
                  ref="ref_notes"
                  v-model="props.item.properties.notes"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  @click.stop="
                    methodEditSnowmakingAirwatergunGeoJson({
                      model: $refs.ref_model.value,
                      gun_style: $refs.ref_gun_style.value,
                      jack_style: $refs.ref_jack_style.value,
                      valve: $refs.ref_valve.value,
                      was_demo: $refs.ref_was_demo.value,
                      cfm: $refs.ref_cfm.value,
                      flow_gpm: $refs.ref_flow_gpm.value,
                      length: $refs.ref_length.value,
                      serial: $refs.ref_serial.value,
                      gun_base: $refs.ref_gun_base.value,
                      skid: $refs.ref_skid.value,
                      status: $refs.ref_status.value,
                      acquired: $refs.ref_acquired.value,
                      purchased: $refs.ref_purchased.value,
                      notes: $refs.ref_notes.value,
                      location: $refs.ref_location.value,
                      moved_by: $refs.ref_moved_by.value
                    });
                    disable_edit = true;
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              confirm_delete = false;
              disable_edit = true;
              methodToggleSingleLayer('snowmaking', 'airwaterguns', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      disable_edit: true,
      confirm_delete: false,
      solo: true,
      opt_gun_type: [{ text: "Auto" }, { text: "AutoTWR" }, { text: "Manual" }],
      opt_gun_style: [
        { text: "Polecat" },
        { text: "Wizzard" },
        { text: "HKD Fan" },
        { text: "Puma" },
        { text: "Super Puma" },
        { text: "T40 Techno" },
        { text: "WizKid" },
        { text: "T40 Techno" }
      ],
      opt_comp_type: [
        { text: "5" },
        { text: "10" },
        { text: "23" },
        { text: "25" },
        { text: "43" },
        { text: "47" }
      ],
      opt_fan_hp: [
        { text: "10" },
        { text: "15" },
        { text: "20" },
        { text: "25" },
        { text: "30" },
        { text: "35" },
        { text: "36" }
      ],
      opt_amps: [{ text: "30" }, { text: "60" }],
      opt_status: [
        { text: "Active" },
        { text: "Inactive" },
        { text: "Retired" },
        { text: "Other" }
      ]
    };
  },
  computed: {
    computedLocation() {
      // Calculates the current gun_num based on coordinates
      let allLocations = this.computedLocations;
      let location = this.computedLatLng;
      const single = allLocations.filter(
        (item) => item.value[0] === location[0].geometry.coordinates[0]
      );
      return single[0].text;
    },
    computedGunJack() {
      const airwaterguns =
        this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
          .features;
      const gunJacks = [];
      airwaterguns.map((item) => {
        gunJacks.push(item.properties.jack_style);
      });
      const uniqueJacks = Array.from(new Set(gunJacks));
      let finalResults = [];
      uniqueJacks.map((item) => {
        if (item !== null && item !== "") {
          finalResults.push({
            text: item
          });
        }
        finalResults.push({
          text: "Unknown"
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedGunSkid() {
      const airwaterguns =
        this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
          .features;
      const gunSkids = [];
      airwaterguns.map((item) => {
        gunSkids.push(item.properties.skid);
      });
      const uniqueSkids = Array.from(new Set(gunSkids));
      let finalResults = [];
      uniqueSkids.map((item) => {
        if (item !== null && item !== "") {
          finalResults.push({
            text: item
          });
        }
        finalResults.push({
          text: "Unknown"
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedGunBase() {
      const airwaterguns =
        this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
          .features;
      const gunBases = [];
      airwaterguns.map((item) => {
        gunBases.push(item.properties.gun_base);
      });
      const uniqueBases = Array.from(new Set(gunBases));
      let finalResults = [];
      uniqueBases.map((item) => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedGunModel() {
      const airwaterguns =
        this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
          .features;
      const gunModels = [];
      airwaterguns.map((item) => {
        gunModels.push(item.properties.model);
      });
      const uniqueModels = Array.from(new Set(gunModels));
      let finalResults = [];
      uniqueModels.map((item) => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedValve() {
      const airwaterguns =
        this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
          .features;
      const valve = [];
      airwaterguns.map((item) => {
        valve.push(item.properties.valve);
      });
      const uniqueValves = Array.from(new Set(valve));
      let finalResults = [];
      uniqueValves.map((item) => {
        if (item !== null) {
          finalResults.push({
            text: item
          });
        }
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedGunStyle() {
      const airwaterguns =
        this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
          .features;
      const gunStyles = [];
      airwaterguns.map((item) => {
        gunStyles.push(item.properties.gun_style);
      });
      const uniqueStyles = Array.from(new Set(gunStyles));
      let finalResults = [];
      uniqueStyles.map((item) => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedSameLocations() {
      if (this.computedSnowmakingAirwatergunVisibility) {
        // all airwaterguns
        const airwaterguns =
          this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
            .features;

        // The airwatergun that's been clicked on
        const currentLocation = airwaterguns.filter(
          (item) => item.properties.id == this.computedSnowmakingAirwatergunId
        );

        // filter all airwaterguns that are at the same location that's been clicked on
        const results = airwaterguns.filter(
          (item) =>
            item.geometry.coordinates[0] ===
              currentLocation[0].geometry.coordinates[0] &&
            item.geometry.coordinates[1] ===
              currentLocation[0].geometry.coordinates[1] &&
            item.properties.id !== this.computedSnowmakingAirwatergunId
        );

        const sortedResults = results.sort((a, b) =>
          a.properties.gun_num < b.properties.gun_num ? -1 : 1
        );
        // Return all airwaterguns at same location as currently viewed airwatergun.
        return sortedResults;
      }
      return [];
    },
    computedLocations() {
      if (this.computedSnowmakingAirwatergunVisibility) {
        const hydrants =
          this.$store.state.mapLayers.snowmaking.layers.hydrants.geojson
            .features;
        let locations = [];
        if (hydrants) {
          hydrants.map((item) => {
            locations.push({
              text: item.properties.hydrnt_num,
              value: item.geometry.coordinates[0]
            });
          });
        }
        let sortedLocations = locations.sort((a, b) =>
          a.text < b.text ? -1 : 1
        );
        return sortedLocations;
      }
      return [];
    },
    computedLatLng() {
      if (
        this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
          .features
      ) {
        const airwaterguns =
          this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
            .features;
        const result = airwaterguns.filter(
          (item) => item.properties.id == this.computedSnowmakingAirwatergunId
        );
        return result;
      }
      return [];
    },
    computedAirwatergunNum() {
      if (this.computedSnowmakingAirwatergunVisibility) {
        const airwaterguns =
          this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
            .features;
        // grabs the fan_num of the currently viewed ID
        let result = airwaterguns.filter(
          (item) => item.properties.id == this.computedSnowmakingAirwatergunId
        );
        return `${result[0].properties.length}' ${result[0].properties.gun_style} #${result[0].properties.gun_number}`;
      }
      return [];
    },
    computedSnowmakingAirwatergunGeoJsonFeature() {
      if (
        this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
          .features
      ) {
        const airwaterguns =
          this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
            .features;
        const result = airwaterguns.filter(
          (item) => item.properties.id == this.computedSnowmakingAirwatergunId
        );
        return result;
      }
      return [];
    },
    computedSnowmakingAirwatergunVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns
        .visibility.singleView;
    },
    computedSnowmakingAirwatergunsLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns.loading;
    },
    computedSnowmakingAirwatergunId() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns
        .visibility.singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodGetHydrntNum(coords) {
      console.log(JSON.stringify(coords));
    },
    // method to get geojson
    methodGetSnowmakingHydrantGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants",
        dept: "snowmaking",
        layer: "hydrants",
        token: this.computedAuthToken
      });
    },
    methodGetSnowmakingAirwatergunGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/snowmaking/airwaterguns",
        dept: "snowmaking",
        layer: "airwaterguns",
        token: this.computedAuthToken
      });
    },
    methodDeleteSnowmakingAirwatergunGeoJson() {
      this.$store.dispatch("actionDeleteGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/airwaterguns/" +
          this.computedSnowmakingAirwatergunId,
        dept: "snowmaking",
        layer: "airwaterguns",
        token: this.computedAuthToken
      });
    },
    methodEditSnowmakingAirwatergunGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: data.location
            },
            properties: {
              model: data.model,
              gun_style: data.gun_style,
              jack_style: data.jack_style,
              valve: data.valve,
              was_demo: data.was_demo,
              cfm: data.cfm,
              flow_gpm: data.flow_gpm,
              length: data.length,
              serial: data.serial,
              gun_base: data.gun_base,
              skid: data.skid,
              status: data.status,
              acquired: data.acquired,
              purchased: data.purchased,
              notes: data.notes,
              gun_location: this.computedLocation,
              edit_by: this.computedAuth.profile.email,
              moved_by: data.moved_by
            }
          }
        ]
      };
      this.$store
        .dispatch("actionEditGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/airwaterguns/" +
            this.computedSnowmakingAirwatergunId,
          dept: "snowmaking",
          layer: "airwaterguns",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(
          () =>
            this.methodToggleSingleLayer("snowmaking", "airwaterguns", false),
          setTimeout(() => {
            this.methodGetSnowmakingAirwatergunGeoJson();
          }, 250)
        );
    },
    methodCloseListLayer(dept, layer) {
      this.$store.commit("mutationCloseListLayer", {
        dept: dept,
        layer: layer
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.airwaterguns.visibility.singleView":
      function (newValue) {
        if (newValue) {
          this.methodGetSnowmakingHydrantGeoJson();
          this.methodGetSnowmakingAirwatergunGeoJson();
        }
      },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson": function (
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
